import router from '@/router'; // 引入 router 实例
export const getLocalizedPath = (path) => {
  const currentLang =
    router.currentRoute.value.params.lang ||
    localStorage.getItem('language') ||
    'en';
  return `/${currentLang}${path.startsWith('/') ? path : '/' + path}`;
};
